@if (isLoading) {
<div section class="flex-column" style="align-items: center; height: 100%; padding: 50px;">
  @if (loadingLogo) {
  <img [src]="loadingLogo" style="max-width: 100%;" [draggable]="false" />
  }

  <span>loading...</span>
</div>
} @else {
<section class="product-upsell-modal">
  <h2>{{ data.prompt }}</h2>
  <ul>
    @for (product of upsellProducts(); track product.id) {
      <li class="product-upsell-modal-item" style="flex: 1;">
        <div class="flex-row" style="align-items: center;">
          @if (product.imageBase && showImages) {
            <img [src]="product.imageBase" loading="lazy" style="margin-right: 6px;" />
          }
  
          <div class="flex-column" style="align-items: baseline;">
            <div style="font-weight: bold; text-align: left;">{{ product.name }}</div>

            @if (product.nutritionSummary) {
              <span>Calories:</span>
              <span>{{ product.nutritionSummary }}</span>
            }
          </div>
        </div>

        <div class="product-upsell-modal-price">
          @if (product.isProductSimple) {
            {{ product.priceSummary }}
            <app-quantity [value]="product.quantity" (add)="increaseQuantity(product)" (minus)="decreaseQuantity(product)"></app-quantity>
          } @else {
            <button mat-flat-button (click)="openProductModal(product)">
              {{ product.priceSummary }}
              <mat-icon iconPositionEnd>navigate_next</mat-icon>
            </button>
          }
        </div>
      </li>
    }
  </ul>
  <!-- footer -->
  <div class="product-upsell-modal-footer disable-select">
    <button mat-button class="button-cancel" (click)="cancel()">
      No, thanks
    </button>
    <button class="button-cta button-action-mat button-action-1"
            tabindex="-1"
            mat-button
            [disabled]="price === 0"
            (click)="addProductToBasket()">
      <div class="flex flex-center" style="width: 100%;">
        @if (!isMobile) {
          <mat-icon style="margin-right: 3px">add_circle</mat-icon>
        }

        <span>Add to cart</span>

        @if (price) {
          <span>&nbsp;({{ price | currency:'GBP' }})</span>
        }
      </div>
    </button>
  </div>
</section>
}

<ng-template #ProductModal>
  <app-product [productView]="productView" [occasion]="data.occasion" (onClose)="closeProductModal()"></app-product>
</ng-template>

<ng-template #DealModal>
  <app-deals [deal]="selectedDeal" [occasion]="data.occasion" group="basket-upsell" (close)="closeDealModal()"></app-deals>
</ng-template>
